module.exports = __webpack_public_path__ + "f9e2304b991a880f9a440c50efcd9b48.svg";